import { render, staticRenderFns } from "./CreateDuePage.vue?vue&type=template&id=150a553c&"
import script from "./CreateDuePage.vue?vue&type=script&lang=js&"
export * from "./CreateDuePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports